import { Type } from '../types.mjs';
import { findNode, findAllNodesSafe } from '../../../../../core/queries/findNode.mjs';
import { isElement } from '../../../../../core/utilities/nodes/elements/isElement.mjs';

function findLink(editor, at = editor.selection) {
  return findNode(editor, {
    at: at != null ? at : undefined,
    match: {
      type: Type
    }
  });
}
function findLinks(editor, at = editor.selection) {
  return findAllNodesSafe(editor, {
    at: at != null ? at : undefined,
    match: node => isElement(node) && node.type === Type
  });
}

export { findLink, findLinks };
